import { useLinkClickHandler } from "react-router-dom";

export const previewData = [
  {
    id: 4,
    name: "Curse of Strahd: Plight of the Sunseekers",
    img: "https://i.imgur.com/fx9tAT8.png",
    link: "https://sunseekers.drewford.dev/"
  },
  {
    id: 1,
    name: "Cozy Cuddles",
    img: "https://i.imgur.com/OjdPoW7.png",
    link: "https://cozy-cuddles.drewford.dev"
  },
  {
    id: 2,
    name: "Marathon",
    img: "https://i.imgur.com/3Tg2GrG.jpg",
    link: "https://watch-marathon.netlify.app"
  },
  {
    id: 13,
    name: "Curse of Strahd: Durst Manor",
    img: "https://i.imgur.com/q1UVNrk.png",
    link: "https://death-house.drewford.dev"
  },
  {
    id: 3,
    name: "Card Games | by Web Slammers",
    img: "https://i.imgur.com/YlTkEuV.png",
    link: "https://card-slam.netlify.app"
  },
  {
    id: 5,
    name: "Tailored Tails",
    img: "https://i.imgur.com/SblpKWD.png",
    link: "https://tailoredtails.netlify.app"
  },
  {
    id: 6,
    name: "Sudoku",
    img: "https://i.imgur.com/t9UQlme.png",
    link: "https://sudoku-slam.netlify.app"
  },
  {
    id: 7,
    name: "Dwayne the Shell | Companion Guide",
    img: "https://i.imgur.com/sga8piV.png",
    link: "https://dwayne.drewford.dev"
  },
  {
    id: 8,
    name: "Natours",
    img: "https://i.imgur.com/Ho4JL3Z.png",
    link: "https://natours.drewford.dev"
  },
  {
    id: 9,
    name: "nexter",
    img: "https://i.imgur.com/6mGTniU.png",
    link: "https://nexter-by-drewford.netlify.app"
  },
  {
    id: 10,
    name: "trillo",
    img: "https://i.imgur.com/mRxNPcf.png",
    link: "https://trillo-by-drewford.netlify.app"
  },
  {
    id: 11,
    name: "Poster Children",
    img: "https://i.imgur.com/OkMa0xM.png",
    link: "https://poster-children.netlify.app/"
  },
  {
    id: 12,
    name: "Delavega Autoplex",
    img: "https://i.imgur.com/WWvB4QC.png",
    link: "https://delavegaautoplex.netlify.app"
  },
  {
    id: 14,
    name: "Pokemon Picker",
    img: "https://i.imgur.com/eDmMzYA.png",
    link: "https://gotta-pick-em-all.netlify.app"
  },
  {
    id: 15,
    name: "Cook Family Crossword",
    img: "https://i.imgur.com/uR5LHeW.png",
    link: "https://cook-crossword.netlify.app"
  },

  {
    id: 16,
    name: "Victor Alberto Photography",
    img: "https://i.imgur.com/AbNB2uF.png",
    link: "https://victoralbertophotography.netlify.app/"
  },

  {
    id: 17,
    name: "Drewford's List",    
    img: "https://i.imgur.com/mt4Idyv.png",
    link: "https://drewfordslist.netlify.app"
  },
  {
    id: 18,
    name: "Connect 4",
    img: "https://i.imgur.com/X1ltYe2.png",
    link: "https://connect4bydrewford.netlify.app"
  },
  {
    id: 19,
    name: "Puppy Clicker",
    img: "https://i.imgur.com/L8uk5oR.png?1",
    link: "https://puppy-clicker.netlify.app"
  },
  {
    id: 20,
    name: "Pixelate",
    img: "https://i.imgur.com/GJcAJt4.png",
    link: "https://pixel8game.netlify.app"
  },
  {
    id: 21,
    name: "FitnessTracker",
    img: "https://i.imgur.com/x2VCp0B.png",
    link: "https://fitness-by-prestige-worldwide.netlify.app"
  },
  {
    id: 22,
    name: "Wizard News",
    img: "https://i.imgur.com/kXTLBtf.png",
    link: "https://wizardnewswithpnd.fly.dev"
  },
  {
    id: 23,
    name: "Movie Mayhem",
    img: "https://i.imgur.com/9zFb5XE.png",
    link: "https://moviemayhem.netlify.app"
  },
  {
    id: 24,
    name: "Beyond the Book",
    img: "https://i.imgur.com/8HhXvXE.png",
    link: "https://beyondthebook.netlify.app"
  },
  {
    id: 25,
    name: "Homestead List",
    img: "https://i.imgur.com/uOYKUJu.png",
    link: "https://homesteadlist.netlify.app"
  },
  {
    id: 26,
    name: "Puppy Bowl",
    img: "https://i.imgur.com/f9opkZT.png",
    link: "https://puppybowlbydrewford.netlify.app"
  }
]